export default "__VITE_ASSET__BLOkCXNi__"